import { useState, useMemo, useCallback, useEffect } from 'react';
import classnames from 'classnames';

interface Resource {
  src: string;
  type?: string;
}

interface PropTypes {
  poster: string;
  source: Resource;
}

const MockVideoPlayer = (props: PropTypes) => {
  const { poster, source } = props;

  const [isPosterLoading, setIsPosterLoading] = useState(false);
  const [posterDataURL, setPosterDataURL] = useState('');

  const videoClassName = useMemo(() => {
    return classnames('intelligence-video-player video-js', { 'vjs-waiting': isPosterLoading });
  }, [isPosterLoading]);

  const loadImage = useCallback((src: string): Promise<string> => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.addEventListener('load', () => {
        resolve(src);
      }, false);
      image.addEventListener('error', (e) => {
        reject(e);
      }, false);
      image.setAttribute('src', src);
    });
  }, []);

  const updatePoster = useCallback(async (src: string) => {
    try {
      setIsPosterLoading(true);
      const dataURL = await loadImage(src);
      setPosterDataURL(dataURL);
    } catch (e) {
      console.error(e);
      setPosterDataURL('');
    } finally {
      setIsPosterLoading(false);
    }
  }, [loadImage]);

  const handlePlay = useCallback(() => {
    if (!source || !source.src) return;
    window.open(source.src);
  }, [source]);

  useEffect(() => {
    updatePoster(poster);
  }, [poster]);

  return (
    <div className="intelligence-swiper-video-wrapper">
      <div className="intelligence-video-player-container" style={{width: '100%', height: '100%'}}>
        <div className={videoClassName} style={{padding: '20px 0', width: '100%', height: '100%', backgroundColor: '#000'}}>
          <div style={{width: '100%', height: '100%', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundSize: 'contain', backgroundImage: `url(${posterDataURL})`}}>
            <span className="vjs-big-play-button" style={{cursor: 'pointer'}} onClick={handlePlay}></span>
            <div className="vjs-loading-spinner">
              <span className="vjs-control-text">Video Player is loading.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MockVideoPlayer;
